import {Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../../../../../../i18n/translations';

export function SeniorAttachmentsEmpty() {
  const {t} = useTranslation();

  return (
    <Stack className="care-table-empty" justifyContent="center" alignItems="center">
      <h3 className="occurrences-empty-title">{t(translations.user_attachments.empty.title)}</h3>
      <Typography>{t(translations.user_attachments.empty.subtitle)}</Typography>
    </Stack>
  );
}
